// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { savedOrderDetailsOrderInformationStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsOrderInformation";
import xOrderInformationStyles from "@tps/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { css } from "styled-components";

savedOrderDetailsOrderInformationStyles.orderDateTitle = {
    ...xOrderInformationStyles.labelWithDots,
};
savedOrderDetailsOrderInformationStyles.orderDateText = {
    ...xOrderInformationStyles.value,
};
savedOrderDetailsOrderInformationStyles.shippingAddressTitle = {
    ...xOrderInformationStyles.address?.heading,
};
savedOrderDetailsOrderInformationStyles.billingAddressTitle = {
    ...xOrderInformationStyles.address?.heading,
};

savedOrderDetailsOrderInformationStyles.mainInformationGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        flex-direction: row;
    `,
};
